import { animate, AnimationTriggerMetadata, state, style, transition, trigger } from '@angular/animations';

export const sidenavToggeling: AnimationTriggerMetadata = trigger('sidenavToggeling', [
  state(
    'collapsed',
    style({
      height: 0,
    }),
  ),
  state(
    'expanded',
    style({
      height: '*',
    }),
  ),
  transition('collapsed <=> expanded', animate('250ms cubic-bezier(0.1, 0, 0.2, 1)')),
]);
